/*
 * YOONITE application server
 *
 * iconCssHelper.js
 * Last update: 03.06.2020 by thomas
 *
 * (c) 2019 FSZ GmbH
 * All rights reserved.
 */

'use strict';

export type ImageType = 'itemtype' | 'nbar' | 'ntree' | 'byRef';

/**
 * Build and return the CSS class name
 *
 * @param type
 * @param key CI_KEY of appropriate Image item
 * @param schema the database schema
 * @param includeLeadingDot include the leading dot of css class (for css file) or not (for usage in html)
 */
export const getIconCssClassName = ( type : ImageType, key : string, schema : Schema | '' = '', includeLeadingDot : boolean = true ) : string => {
    const iconPrefixes = {
        itemtype: 'icon-itemtype-',
        nbar    : 'icon-nbar-',
        ntree   : 'icon-ntree-',
        byRef   : 'icon-'
    };

    const keyPrefixes = {
        itemtype: '',
        nbar    : 'CP.nbar.',
        ntree   : 'CP.ntree.',
        byRef   : 'icon-'
    };

    key = key.replace( /:/g, '_' );

    // get css class prefix
    let retVal = ( iconPrefixes[ type ] || '' );

    // build the css class name for itemtype icon
    if ( type === 'itemtype' && schema ) {
        const keyPrefix = 'CP.MetaModel.' + schema.toUpperCase() + '.ItemType.';

        const keyParts = key.replace( keyPrefix, '' ).split( '.' );
        const itemType = keyParts.shift();
        const itemIconType = keyParts.length ? keyParts.join( '.' ) : 'standard';

        if ( [ 'standard', 'list', 'add', 'sum' ].includes( itemIconType ) ) {
            retVal += schema + '-' + itemType + ( itemIconType !== 'standard' ? '-' + itemIconType : '' );
        }
        if ( itemIconType !== 'standard' ) {
            retVal += retVal !== '' ? ',\n' : '';
            retVal += '.' + iconPrefixes.itemtype + schema + '-' + itemType + '.' + itemIconType;
        }
    }
    // build the css class name for nbar and ntree icons
    else {
        retVal += key.replace( keyPrefixes[ type ], '' ).replace( /\./g, '_' );
    }

    if ( !includeLeadingDot ) {
        retVal = retVal.replace( /\./g, ' ' );
    }

    retVal = retVal.toLowerCase();

    return retVal;
}

/**
 * Build and return the CSS class name
 *
 * @param key CI_KEY of appropriate Style item
 */
export const getStyleCssClassName = ( key : string ) : string => {
    return key.replaceAll( /:/g, '_' ).replaceAll( /[^a-zA-Z0-9_-]+/g, '-' ).toLowerCase();
}
